import { defineMessages } from 'react-intl'

export default defineMessages({
  memberCount: {
    id: 'hubs.member.count',
    defaultMessage: `{count, plural,
      one {{count} Member}
      other {{count} Members}
    }`,
  },
  collaborators: {
    id: 'hubs.collaborators',
    defaultMessage: 'Collaborators',
  },
  changedUserRoleError: {
    id: 'hubs.role.change.error',
    defaultMessage: "Failed to change {userName}'s role to {role}.",
  },
  changedUserRoleSuccess: {
    id: 'hubs.role.change.success',
    defaultMessage: "Changed {userName}'s role to {role}.",
  },
  upNext: {
    id: 'hubs.navigation.up.next',
    defaultMessage: `Up Next`,
  },
  upNextIn: {
    id: 'hubs.navigation.up.next.in',
    defaultMessage: `Up Next in {collectionName}`,
  },
  moreFrom: {
    id: 'hubs.navigation.more.from',
    defaultMessage: `More from`,
  },
  backTo: {
    id: 'hubs.navigation.back.to',
    defaultMessage: `Back to`,
  },
  emptyCollection: {
    id: 'hubs.collection.empty',
    defaultMessage: `It looks like this collection is empty at the moment`,
  },
  youHaveBeenInvited: {
    id: 'hubs.invite.pending.title',
    defaultMessage: `{userName} has invited you to be part of this hub.`,
  },
  acceptToGetAccess: {
    id: 'hubs.invite.pending.message',
    defaultMessage: `Accept to get full hub access and keep updated.`,
  },
  invites: {
    id: 'hubs.invites',
    defaultMessage: `Invites`,
  },
  invite: {
    id: 'hubs.invite',
    defaultMessage: `Invite`,
  },
  inviteAccept: {
    id: 'hubs.invite.accept',
    defaultMessage: `Accept`,
  },
  inviteIgnore: {
    id: 'hubs.invite.ignore',
    defaultMessage: `Ignore`,
  },
  groupMembers: {
    id: 'hubs.group.members',
    defaultMessage: `Members`,
  },
  leave: {
    id: 'hubs.leave',
    defaultMessage: 'Leave',
  },
  leaveDisallowed: {
    id: 'hubs.leave.disallowed',
    defaultMessage: `Cannot leave a hub that you own`,
  },
  leaveConfirmation: {
    id: 'hub.leave.confirmation',
    defaultMessage: `Are you sure you want to leave this hub?`,
  },
  subscribe: {
    id: 'hubs.subscribe',
    defaultMessage: 'Subscribe',
  },
  subscribed: {
    id: 'hubs.subscribed',
    defaultMessage: 'Subscribed',
  },
  unsubscribe: {
    id: 'hubs.unsubscribe',
    defaultMessage: 'Unsubscribe',
  },
  points: {
    id: 'hub.points',
    defaultMessage: `Points`,
  },
  joinHub: {
    id: 'hubs.join',
    defaultMessage: `Join {hubName}`,
  },
  subscribeToHub: {
    id: 'hubs.subscribe.to',
    defaultMessage: `Subscribe to {hubName}`,
  },
  joinModalMessage: {
    id: 'hubs.join.modal',
    defaultMessage: `Engage and keep up to date with all the latest content from this Hub.`,
  },
  inviteMembers: {
    id: 'hub.invite.members',
    defaultMessage: `Invite members`,
  },
  viewGroupPage: {
    id: 'hubs.view.group.page',
    defaultMessage: `View group page`,
  },
  searchUsers: {
    id: 'hubs.group.search.users',
    defaultMessage: 'Search users',
  },
  searchNoResults: {
    id: 'hubs.group.search.noresults',
    defaultMessage: `No posts found for "{query}"`,
  },
  noUsers: {
    id: 'hubs.group.no.users',
    defaultMessage: 'No users to display',
  },
  noPendingInvites: {
    id: 'hubs.group.no.pending.invites',
    defaultMessage: 'No pending invites',
  },
  leaveCommunity: {
    id: 'hubs.group.leave.community',
    defaultMessage: 'Leave Community',
  },
  downloadCcpaList: {
    id: 'hubs.group.download',
    defaultMessage: 'CCPA list',
  },
  downloadedCcpaList: {
    id: 'hubs.group.downloaded',
    defaultMessage: 'Successfully downloaded opt-outs list',
  },
  removeUser: {
    id: 'hubs.group.remove.community',
    defaultMessage: 'Remove user from community',
  },
  successfullyRemovedUser: {
    id: 'pkg.domain.hubs.remove.user.success',
    defaultMessage: 'Successfully removed user',
  },
  joinCommunity: {
    id: 'hubs.group.join.community',
    defaultMessage: 'Join Community',
  },
  group: {
    id: 'hubs.group',
    defaultMessage: 'Group',
  },
  lastOwnerMessage: {
    id: 'hubs.group.last.owner.message',
    defaultMessage: 'Cannot leave hub as the last owner',
  },
  removeThisPerson: {
    id: 'hubs.group.remove.this.person',
    defaultMessage: 'Remove this person from your team',
  },
  changeRole: {
    id: 'hubs.group.change.role',
    defaultMessage: 'Change Role',
  },
  deleteHub: {
    id: 'hubs.group.delete.hub',
    defaultMessage: 'Delete Hub',
  },
  completeActionsBelow: {
    id: 'hubs.group.complete.actions.below',
    defaultMessage: 'Complete all actions mentioned below',
  },
  moderatorItem1: {
    id: 'hubs.group.moderator.item.one',
    defaultMessage: 'Modify hub name, description, or privacy',
  },
  moderatorItem2: {
    id: 'hubs.group.moderator.item.two',
    defaultMessage: 'Configure design settings and add-ons',
  },
  moderatorItem3: {
    id: 'hubs.group.moderator.item.three',
    defaultMessage: 'Invite other moderators or change roles',
  },
  moderatorItem4: {
    id: 'hubs.group.moderator.item.four',
    defaultMessage: 'Complete all actions mentioned below',
  },
  collaboratorItem1: {
    id: 'hubs.group.collaborator.item.one',
    defaultMessage: 'Publish or compose new posts in a hub',
  },
  collaboratorItem2: {
    id: 'hubs.group.collaborator.item.two',
    defaultMessage: 'Manage hub content and set up feeds',
  },
  collaboratorItem3: {
    id: 'hubs.group.collaborator.item.three',
    defaultMessage: 'Complete all actions mentioned below',
  },
  memberItem1: {
    id: 'hubs.group.member.item.one',
    defaultMessage: 'Comment on or like posts',
  },
  memberItem2: {
    id: 'hubs.group.member.item.two',
    defaultMessage: 'Follow and receive updates from a hub',
  },
  promote: {
    id: 'hubs.group.promote',
    defaultMessage: 'Promote',
  },
  promoteToOwner: {
    id: 'hubs.group.promote.to.owner',
    defaultMessage: 'Promote to Owner?',
  },
  promoteConfirm: {
    id: 'hubs.group.promote.confirm',
    defaultMessage: 'Do you want to promote {userName} to an owner? This action cannot be undone.',
  },
  removeUserConfirm: {
    id: 'hubs.group.remove.confirm',
    defaultMessage: 'Are you sure that you want to remove {userName} from this community?',
  },
  leaveCommunityConfirm: {
    id: 'hubs.group.leave.confirm',
    defaultMessage: 'Are you sure that you want to leave this community?',
  },
  searchHubPlaceholder: {
    id: 'hubs.search.placeholder',
    defaultMessage: `Search {hub}...`,
  },
  searchNameOrUsername: {
    id: 'hubs.search.name.or.username',
    defaultMessage: `Search a name or username`,
  },
  linkToSourceDescription: {
    id: 'hubs.link.to.source.description',
    defaultMessage: `Redirect users automatically to the external source.`,
  },
  metaTags: {
    id: 'hubs.post.settings.meta.tags',
    defaultMessage: 'Meta Tags',
  },
  postSettingsDatePickerLabel: {
    id: 'hubs.post.settings.date.picker.label',
    defaultMessage: 'Defined by the date the post is published.',
  },
  postSettingsDateAuto: {
    id: 'hubs.post.settings.date.auto',
    defaultMessage: 'Auto',
  },
  postSettingsDateCustom: {
    id: 'hubs.post.settings.date.custom',
    defaultMessage: 'Custom',
  },
  revokeInvite: {
    id: 'hubs.group.invites.revoke',
    defaultMessage: 'Revoke Invite',
  },
  revokeInviteConfirmHeading: {
    id: 'hubs.group.invite.revoke.confirm.heading',
    defaultMessage: 'Revoke Invite',
  },
  revokeInviteConfirmText: {
    id: 'hubs.group.invite.revoke.confirm.text',
    defaultMessage: 'Are you sure you wish to remove {email} from invite list?',
  },
  openCollectionsSidebar: {
    id: 'hubs.collections.more',
    defaultMessage: 'Open list of available post collections',
  },
  displayMemberEngagementPage: {
    id: 'hubs.member.engagement.page',
    defaultMessage: 'Member Engagement',
  },
  hubEngagementMetrics: {
    id: 'hubs.engagement.metrics',
    defaultMessage: 'Hub Engagement Metrics',
  },
  hubAnalytics: {
    id: 'hubs.engagement.analytics',
    defaultMessage: 'Analytics',
  },
  selectHub: {
    id: 'analytics.member.engagement.selectHub',
    defaultMessage: 'Choose a hub.',
  },
  chartsInitialState: {
    id: 'analytics.member.engagement.chartsInitialState',
    defaultMessage: 'Please choose a hub to view member engagement information.',
  },
  chartsEmptyState: {
    id: 'analytics.member.engagement.chartsEmptyState',
    defaultMessage: "We don't have member engagement information for this hub.",
  },
  chartsErrorState: {
    id: 'analytics.member.engagement.chartsErrorState',
    defaultMessage:
      'Something went wrong while retrieving member engagement information for this hub.',
  },
  eventDate: {
    id: 'analytics.member.engagement.event.date',
    defaultMessage: 'Date',
  },
  viewPost: {
    id: 'analytics.member.engagement.viewPost',
    defaultMessage: 'View post',
  },
  createPost: {
    id: 'analytics.member.engagement.createPost',
    defaultMessage: 'Create post',
  },
  commentPost: {
    id: 'analytics.member.engagement.commentPost',
    defaultMessage: 'Comment on post',
  },
  likePost: {
    id: 'analytics.member.engagement.likePost',
    defaultMessage: 'Like post',
  },
  openActivity: {
    id: 'analytics.member.engagement.openActivity',
    defaultMessage: 'Open an activity',
  },
  avgEvents: {
    id: 'analytics.member.engagement.avgEvents',
    defaultMessage: 'Average number of events',
  },
  avgEventsPerUser: {
    id: 'analytics.member.engagement.avgEventsPerUser',
    defaultMessage: 'Average number of events per user',
  },
  avgEventsPerSession: {
    id: 'analytics.member.engagement.avgEventsPerSession',
    defaultMessage: 'Average number of events per session',
  },
  avgEventsPerSessionPerUser: {
    id: 'analytics.member.engagement.avgEventsPerSessionPerUser',
    defaultMessage: 'Average number of events per session per user',
  },
  memberEngagementEventType: {
    id: 'analytics.member.engagement.memberEngagementEventType',
    defaultMessage: 'Member engagement by event type',
  },
  memberEngagementAverage: {
    id: 'analytics.member.engagement.memberEngagementAverage',
    defaultMessage: 'Member engagement by event averages',
  },
  memberIdCopy: {
    id: 'hubs.group.member.copy',
    defaultMessage: 'Member ID has been copied',
  },
  memberId: {
    id: 'hubs.member.id',
    defaultMessage: 'Member ID:',
  },
  copyMemberId: {
    id: 'hubs.member.copy',
    defaultMessage: 'Copy member ID',
  },
  generalServerError: {
    id: 'common.error.wrong',
    defaultMessage: 'Something went wrong',
  },
  successfullyLeftHub: {
    id: 'hubs.success.msg',
    defaultMessage: 'Successfully left hub',
  },
  successfullyRemovedInvite: {
    id: 'hubs.invite.remove.success',
    defaultMessage: 'Successfully removed invite from hub',
  },
  inviteRemoveError: {
    id: 'hubs.invite.remove.error',
    defaultMessage: 'Failed to remove invite from hub',
  },
  copy: {
    id: 'hubs.copy',
    defaultMessage: 'Copy',
  },
  sendInvite: {
    id: 'hubs.send.invite',
    defaultMessage: 'Send Invite',
  },
  inviteSentSuccess: {
    id: 'account.invite.sent.success',
    defaultMessage: 'Successfully sent an invite to {userName}',
  },
  inviteExists: {
    id: 'account.invite.already.exists',
    defaultMessage: 'An invite already exists ({email})',
  },
  inviteFailed: {
    id: 'account.invite.failed',
    defaultMessage: 'Failed to invite {email}',
  },
  enterListOfEmails: {
    id: 'account.enter.list.of.emails',
    defaultMessage: `Enter list of emails ...`,
  },
  emailComplianceWarning: {
    id: 'hubs.email.compliance.warning',
    defaultMessage:
      'You are responsible for ensuring email messages are sent in compliance with anti-spam regulations.',
  },
  inviteEmailMessage: {
    id: 'account.invite.email.message',
    defaultMessage: `Invite email message (optional, up to 1024 characters)`,
  },
  inviteToHub: {
    id: 'hubs.invite.to.hub',
    defaultMessage: 'Invite to {hubName}',
  },
  learnMore: {
    id: 'hubs.learn.more',
    defaultMessage: 'Learn more',
  },
  role: {
    id: 'common.role',
    defaultMessage: 'Role',
  },
  errorSomethingWentWrong: {
    id: 'error.errorSomethingWentWrong',
    defaultMessage: 'Something went wrong',
  },
  errorAnErrorOccured: {
    id: 'error.errorAnErrorOccured',
    defaultMessage: 'An error occurred while rendering this page.',
  },
  errorVctraceid: {
    id: 'error.errorVctraceid',
    defaultMessage: 'vctraceid: {vctraceid}',
  },
  errorTryAgainLater: {
    id: 'error.errorTryAgainLater',
    defaultMessage: 'You may want to try again later, or {email}.',
  },
  errorEmailTechnicalSupport: {
    id: 'error.errorEmailTechnicalSupport',
    defaultMessage: 'email technical support',
  },
})
